import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import he from "he";
import { bpVars } from "../../functions/themeAssets";
import { STAGE_PATHS } from "../bigpicture/gameApi";
import { bannerSrc, Loader, StageHeader, SubmitButton } from "../bigpicture/components";
import { formatClock, useStage, useStopwatch } from "../bigpicture/useStage";
import "../styles/bp-closer.css";

/** Challenge 3 — Think Closer: write the team war cry / lyrics (think-closer.php). */
export default function ThinkCloser() {
  const navigate = useNavigate();
  const { game, finish } = useStage(3);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const seconds = useStopwatch(game?.state?.elapsed, !!game);

  if (!game) return <Loader />;
  const theme = game.theme;
  // the point for this challenge is shown the moment the answer is submitted
  const points = game.state.score + (saving ? 1 : 0);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (saving || text.trim() === "") return;
    setSaving(true);
    const result = await finish({ answer: text });
    if (!result) {
      setSaving(false);
      return;
    }
    // a short pause so the new point can be seen, like the original page
    setTimeout(() => navigate(STAGE_PATHS[result.stage], { replace: true }), 1000);
  };

  return (
    <div className="bp-closer" style={bpVars(theme)}>
      <StageHeader clock={formatClock(seconds)} points={points} src={bannerSrc(theme, 3)} alt="Challenge 3" />

      <div className="tf-wrapper">
        <div className="tf-card">
          <div className="tc-intro">
            <p className="tc-intro-title">{he.decode(String(theme.landing_page_title3 || ""))}</p>
            <p className="tc-intro-example">{he.decode(String(theme.landing_page_title3_eg || ""))}</p>
            <p className="tc-intro-question">{he.decode(String(theme.landing_page_title3_question || ""))}</p>
          </div>

          <form onSubmit={onSubmit} style={saving ? { pointerEvents: "none" } : undefined}>
            <div className="tc-answer-wrap">
              <input
                type="text"
                className="tc-answer-input"
                id="question_ans"
                name="question_ans"
                placeholder="Insert Your lyrics"
                value={text}
                onChange={(e) => setText(e.target.value)}
                required
              />
            </div>

            <SubmitButton disabled={saving} />
          </form>
        </div>
      </div>
    </div>
  );
}
